var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_779_3428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3642 3.63289C12.8527 0.12237 7.1481 0.12237 3.6366 3.63289C0.886951 6.38352 0.291491 10.4573 1.83366 13.7888C2.03118 14.2821 2.18491 14.6782 2.18491 15.0626C2.18491 16.1367 1.14868 17.4668 1.8395 18.1576C2.53032 18.8484 3.86039 17.8122 4.92872 17.8054C5.31208 17.8064 5.71587 17.966 6.2082 18.1644C9.5397 19.7056 13.6145 19.1111 16.3642 16.3604C19.0972 13.6275 19.7066 9.57025 18.1843 6.24684",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76953 7.2026V7.15103M6.72401 6.99805C6.60001 6.99805 6.49901 7.09905 6.50001 7.22305C6.50001 7.34705 6.60101 7.44805 6.72501 7.44805C6.84901 7.44805 6.95001 7.34705 6.95001 7.22305C6.95001 7.09805 6.84901 6.99805 6.72401 6.99805Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2307 7.2026V7.15103M13.224 6.99805C13.1 6.99805 12.999 7.09905 13 7.22305C13 7.34705 13.101 7.44805 13.225 7.44805C13.349 7.44805 13.45 7.34705 13.45 7.22305C13.45 7.09805 13.349 6.99805 13.224 6.99805Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30518 12.1386C7.961 12.9929 8.9271 13.5251 10.0003 13.5251C11.0735 13.5251 12.0397 12.9929 12.6955 12.1386",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_779_3428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSmile);
export default __webpack_public_path__ + "static/media/chat-smile.49170646fad6145e33e2e0a54898aab5.svg";
export { ForwardRef as ReactComponent };